import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EULADialogComponent } from '../eula-dialog/eula-dialog.component';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  private redirectUrl: string = '';
  errorMessage: string = '';

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Check for redirect query param (for deep linking)
    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params['redirect'] || '';
    });
  }
  loginForm = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
    agree: new FormControl(false, Validators.requiredTrue)
  });
  username: string = '';
  authenticated: boolean = false;
  showSpinner: boolean = false;


  openEulaDialog(): void {
    const dialogRef = this.dialog.open(EULADialogComponent, {
      width: '700px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  login() {

    let username = this.loginForm.value.username
      ? this.loginForm.value.username
      : "";
    let password = this.loginForm.value.password
      ? this.loginForm.value.password
      : "";

    if (!username || !password || !this.loginForm.value.agree) {
      return;
    }
    this.showSpinner = true;
    this.errorMessage = '';

    this.authService.login(username, password).subscribe({
      next: (res) => {
        this.showSpinner = false;

        // Handle redirect if present (for deep linking)
        if (this.redirectUrl) {
          this.router.navigateByUrl(this.redirectUrl);
        } else {
          this.router.navigate(['/home']);
        }
      }, error: (err) => {
        this.showSpinner = false;

        // Handle specific error messages (like inactive account)
        if (err.error?.message) {
          this.errorMessage = err.error.message;
        } else if (err.status === 403) {
          this.errorMessage = 'Your account has been deactivated. Use the \'Request Access\' button below to request reactivation.';
        } else {
          this.errorMessage = 'Login failed. Please check your credentials.';
        }
      }
    })
  }

  logout() {
    this.authService.logout();
  }

  openCalendly() {
    window.open('https://calendly.com/dwip_shah/30min', '_blank');
  }

}
